/**
 * Volume Rate of Change (VROC)
 *
 * Percentage change in volume over `period` bars.
 * VROC = (Volume − Volume[period]) / Volume[period] × 100
 *
 * Category: Volume | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const vrocIndicator: IndicatorDefinition = {
  id: "vroc",
  name: "Volume Rate of Change",
  shortName: "VROC",
  category: "volume",
  pane: "separate",
  params: [
    { key: "period", label: "Period", type: "number", default: 14, min: 1, max: 200 },
    { key: "color", label: "Color", type: "color", default: "#E91E63" },
  ],
  plots: [
    { key: "vroc", label: "VROC", color: "#E91E63", style: "line", lineWidth: 2, priceScaleId: "vroc" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period } = params;
    const data: { time: number; value: number }[] = [];

    for (let i = period; i < candles.length; i++) {
      const prevVol = candles[i - period].volume || 0;
      const curVol = candles[i].volume || 0;
      const value = prevVol === 0 ? 0 : ((curVol - prevVol) / prevVol) * 100;
      data.push({ time: candles[i].time, value });
    }

    return [{ key: "vroc", data }];
  },
};
